import { render } from "./equipment-documents.vue?vue&type=template&id=bc8a4014&ts=true"
import script from "./equipment-documents.vue?vue&type=script&lang=ts"
export * from "./equipment-documents.vue?vue&type=script&lang=ts"

import "./equipment-documents.vue?vue&type=style&index=0&id=bc8a4014&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__